"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestmentPayment = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPay_1 = require("../../model/hsPay");
var service_1 = require("../../../library/base/service");
var InvestmentPayment = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(InvestmentPayment, _super);
    function InvestmentPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品购买接口';
        _this.code = '105019';
        _this.desc = '理财产品购买接口';
        _this.requestParams = new hsPay_1.InvestmentPaymentRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return InvestmentPayment;
}(service_1.BaseService));
exports.InvestmentPayment = InvestmentPayment;
//# sourceMappingURL=investmentPayment.js.map